import { Injectable } from "@angular/core";

@Injectable({ providedIn: 'root' })
export class AdminModuleListService {

    private _distributionType: string | undefined;

    set distributionType(value: string | undefined) {
        this._distributionType = value;
    }
    get distributionType(): string | undefined {
        return this._distributionType;
    }
}